import { useCallback, useEffect, useState } from 'react';
import {
  EDU_VERIFY_RESEND_COOLDOWN_MS,
  eduVerifyResendRemainingSeconds,
} from '../utils/eduEmailVerification';

/** Client countdown for .edu verification resend. Server also enforces 60s. */
export function useEduVerifyResendCooldown(lastSentMs) {
  const [nowMs, setNowMs] = useState(() => Date.now());
  const [localCooldownUntilMs, setLocalCooldownUntilMs] = useState(0);

  const remainingSeconds = Math.max(
    eduVerifyResendRemainingSeconds(lastSentMs, nowMs),
    localCooldownUntilMs > nowMs ? Math.ceil((localCooldownUntilMs - nowMs) / 1000) : 0,
  );

  useEffect(() => {
    if (remainingSeconds <= 0) return undefined;
    const t = setTimeout(() => setNowMs(Date.now()), 1000);
    return () => clearTimeout(t);
  }, [remainingSeconds]);

  const markSent = useCallback(() => {
    setLocalCooldownUntilMs(Date.now() + EDU_VERIFY_RESEND_COOLDOWN_MS);
    setNowMs(Date.now());
  }, []);

  /** Lift the optimistic cooldown when the server reports the send failed. */
  const clearLocalCooldown = useCallback(() => {
    setLocalCooldownUntilMs(0);
    setNowMs(Date.now());
  }, []);

  return { remainingSeconds, markSent, clearLocalCooldown, canResend: remainingSeconds <= 0 };
}
